<template>
    <div class="GroupItem">
        <div class="GroupName">
            <WText
                :size="12"
                color="gray02"
                class="GroupPropLabel"
            >
                {{ $t('schema.groups.name') }}
            </WText>
            <WInput
                :value="groupName"
                :name="group.key"
                type="text"
                @input="groupName = $event"
            />
        </div>
        <div class="GroupIcon">
            <WText
                :size="12"
                color="gray02"
                class="GroupPropLabel"
            >
                {{ $t('schema.groups.icon') }}
            </WText>
            <WIconSelect
                :value="groupIcon"
                :options="iconsOptions"
                @input="groupIcon = $event"
            />
        </div>
        <WButton
            class="GroupActionButton"
            outline
            color="accent-blue"
            iconLeft="trash"
            @click="deleteGroup"
        />
        <WButton
            class="GroupActionButton"
            color="primary"
            iconLeft="save"
            :disabled="saveDisabled"
            @click="saveGroup"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import projectIcons from '@/utils/projectIcons'

export default {
    name: 'GroupItem',
    props: {
        entityKey: VueTypes.string,
        group: VueTypes.object.def({}),
    },
    data () {
        this.iconsOptions = projectIcons
        return {
            groupKey: '',
            groupName: '',
            groupIcon: '',
        }
    },
    computed: {
        saveDisabled () {
            const equalNames = this.groupName === this.group.name
            const equalIcons = this.groupIcon === this.group.icon
            return equalNames && equalIcons
        },
    },
    mounted () {
        this.groupKey = this.group.key
        this.groupName = this.group.name
        this.groupIcon = this.group.icon
    },
    methods: {
        deleteGroup () {
            this.$emit('delete', this.group)
        },
        saveGroup () {
            this.$emit('save', {
                key: this.groupKey,
                name: this.groupName,
                icon: this.groupIcon,
            })
        },
    },
}
</script>

<style scoped lang="scss">
.GroupItem {
    width: 100%;
    gap: 15px;
    display: flex;
    flex-direction: row;
    .GroupPropLabel {
        margin-bottom: 4px;
    }
    .GroupName {
        display: flex;
        flex-direction: column;
        flex: 1;
        .WInput {
            display: flex;
            flex: 1;
            &::v-deep input {
                height: auto;
                padding: 0 15px;
            }
        }
    }
    .GroupIcon {
        width: 10%;
    }
    .GroupActionButton {
        margin-top: 20px;
    }
}
</style>
